<template>
  <div class="modal modal-sla-complete fade fixed-end" tabindex="-1" role="dialog">
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">Complete SLA</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="alert alert-danger" role="alert">
            <strong>Warning!</strong> Completing this SLA will set the end date to the end
            of this month and billing will stop.
          </div>
        </div>
        <!-- /.modal-body -->

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-bs-dismiss="modal">
            Cancel
          </button>
          <ladda-button
            :on-click="handleCompleteSla"
            type="danger"
            class="btn btn-danger"
            >Complete</ladda-button
          >
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import { mapActions } from "vuex";
import { LaddaButton } from "components/form/input";
import { notify } from "utils";
import { CModal } from "@chameleon/chameleon-vue";

export default {
  props: ["sla"],
  extends: CModal,
  components: {
    LaddaButton,
  },

  methods: {
    ...mapActions("sla", ["completeSLA"]),

    async handleCompleteSla() {
      let payload = {
        id: this.sla.id,
        payload: {},
      };

      return this.completeSLA(payload)
        .then(() => {
          notify.success("SLA successfuly completed.");
          this.close();
          this.$emit("completed");
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            notify.error(
              "Form validation failed, please check your inputs and try again."
            );
          } else {
            notify.error("Failed to update sla details, please try again.");
          }
        });
    },
  },
};
</script>